import type { ExternalTableSchema } from '@packages/table-builder';

export const convertiblesTable: ExternalTableSchema = {
  metadata: {
    title: 'Convertibles',
    entity: 'Convertible',
  },

  dataSource: {
    endpoint: '/api/cap-table/api/app/convertible',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      ParticipantName: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
    },

    filters: [
      {
        name: 'InstrumentType',
        placeholder: 'Instrument Type',
        type: 'select',
        options: [
          { label: 'SAFE', value: 1 },
          { label: 'Convertible Note', value: 2 },
        ],
      },
      {
        name: 'Status',
        placeholder: 'Status',
        type: 'select',
        options: [
          { label: 'Pending', value: 0 },
          { label: 'Published', value: 1 },
          { label: 'Converted', value: 2 },
          { label: 'Cancelled', value: 3 },
        ],
      },
    ],
  },

  columns: [
    {
      field: 'instrumentNumber',
      header: 'Instrument #',
      sortable: true,
      width: 160,
      visibility: 'locked',
    },
    {
      field: 'participantName',
      header: 'Holder',
      sortable: true,
      width: 180,
    },
    {
      field: 'instrumentTypeNormalized',
      header: 'Type',
      type: 'badge',
      sortable: true,
      width: 150,
      align: 'center',
      badge: {
        statusMap: {
          SAFE: 'info',
          'Convertible Note': 'info',
        },
        defaultVariant: 'default',
      },
    },
    {
      field: 'statusNormalized',
      header: 'Status',
      type: 'badge',
      sortable: true,
      width: 140,
      align: 'center',
      badge: {
        statusMap: {
          Pending: 'info',
          Published: 'success',
          Converted: 'default',
          Cancelled: 'error',
        },
        defaultVariant: 'default',
      },
    },
    {
      field: 'principalAmount',
      header: 'Principal',
      type: 'currency',
      sortable: true,
      width: 130,
      align: 'right',
    },
    {
      field: 'remainingPrincipal',
      header: 'Remaining',
      type: 'currency',
      sortable: true,
      width: 130,
      align: 'right',
    },
    {
      field: 'issueDate',
      header: 'Issue Date',
      type: 'date',
      sortable: true,
      width: 120,
    },
    {
      field: 'maturityDate',
      header: 'Maturity Date',
      type: 'date',
      sortable: true,
      width: 120,
    },
    {
      field: 'conversionDiscount',
      header: 'Discount',
      type: 'percentage',
      sortable: true,
      width: 100,
      align: 'right',
    },
    {
      field: 'interestRate',
      header: 'Interest Rate',
      type: 'percentage',
      sortable: true,
      width: 120,
      align: 'right',
    },
    {
      field: 'valuationCap',
      header: 'Valuation Cap',
      type: 'currency',
      sortable: true,
      width: 140,
      align: 'right',
    },

    // ── Column-picker only ──────────────────────────────────────────────
    {
      field: 'securityTypeName',
      header: 'Service Type',
      sortable: true,
      width: 140,
      visibility: 'picker',
    },
    {
      field: 'boardApprovalDate',
      header: 'Board Approval Date',
      type: 'date',
      sortable: true,
      width: 160,
      visibility: 'picker',
    },
  ],

  actions: {
    row: [
      { id: 'VIEW_CONVERTIBLE', label: 'View Details' },
      { id: 'EDIT_CONVERTIBLE', label: 'Edit' },
      { id: 'PUBLISH_CONVERTIBLE', label: 'Publish' },
      { id: 'CANCEL_CONVERTIBLE', label: 'Cancel', variant: 'danger' },
      { id: 'DELETE_CONVERTIBLE', label: 'Delete', variant: 'danger' },
    ],
    bulk: [
      { id: 'PREVIEW_CALCULATION_CONVERTIBLE', label: 'Preview Calculation' },
    ],
    toolbar: {
      primary: {
        id: 'ADD_CONVERTIBLE',
        label: 'Add Convertible',
        icon: 'add_circle',
      },
      secondary: [
        {
          label: 'Downloads',
          icon: 'download',
          type: 'download',
          children: [
            { id: 'DOWNLOAD_TEMPLATE_CONVERTIBLE', label: 'Download Template' },
          ],
        },
        {
          label: 'Import',
          icon: 'upload',
          type: 'upload',
          children: [
            { id: 'IMPORT_CONVERTIBLE', label: 'Import Bulk XLS' },
          ],
        },
      ],
    },
  },

  features: {
    search: { enabled: true },
    selection: { keyField: 'id' },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    columnPreferences: { persistenceKey: 'Convertible', resizable: true, reorderable: true },
  },
};
